import { hasBeenInitialised, markInitialised } from "../../../_utilities";

const copiedDelay = 2000;

export const init = (copyElement?: HTMLElement) => {
  if (typeof window !== "undefined") {
    (copyElement
      ? [copyElement]
      : document.querySelectorAll<HTMLDivElement>(".copy")
    ).forEach(async (copy) => {
      if (!hasBeenInitialised(copy, "copy")) {
        if (!navigator.clipboard) {
          copy.classList.add("copy--unsupported");
          markInitialised(copy, "copy");
          return;
        }

        const button = copy.querySelector(".copy__button");

        button.addEventListener("click", async () => {
          let couldCopy = true;
          if (copy.dataset.text) {
            try {
              await navigator.clipboard.writeText(copy.dataset.text);
            } catch (ex) {
              console.error("Could not copy text: ", ex);
              couldCopy = false;
            }
          }

          const anyDoc = document as any;
          if (anyDoc.startViewTransition) {
            anyDoc.startViewTransition(() => {
              button.classList.add(
                couldCopy ? "copy__button--copied" : "copy__button--not-copied"
              );
              setTimeout(() => {
                anyDoc.startViewTransition(() => {
                  button.classList.remove(
                    couldCopy
                      ? "copy__button--copied"
                      : "copy__button--not-copied"
                  );
                });
              }, copiedDelay);
            });
          } else {
            button.classList.add(
              couldCopy ? "copy__button--copied" : "copy__button--not-copied"
            );
            setTimeout(() => {
              button.classList.remove(
                couldCopy ? "copy__button--copied" : "copy__button--not-copied"
              );
            }, copiedDelay);
          }
        });
        markInitialised(copy, "copy");
      }
    });
  }
};

export default {
  init,
};
